import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { trigger, transition, style, animate } from '@angular/animations';

export interface ImageViewerItem {
    url: string;
    titulo: string;
}

export interface ImageViewerData {
    /** Lista de imágenes para navegar con flechas. */
    imagenes?: ImageViewerItem[];
    /** Índice inicial dentro de `imagenes`. */
    index?: number;
    /** Compatibilidad con el uso anterior (una sola imagen). */
    url?: string;
    titulo?: string;
}

@Component({
    selector: 'app-ofertas-image-viewer',
    templateUrl: './ofertas-image-viewer.component.html',
    styleUrls: ['./ofertas-image-viewer.component.scss'],
    animations: [
        trigger('imgAnim', [
            transition('* => *', [
                style({ opacity: 0, transform: 'scale(0.985)' }),
                animate(
                    '260ms cubic-bezier(0.22, 1, 0.36, 1)',
                    style({ opacity: 1, transform: 'scale(1)' })
                ),
            ]),
        ]),
    ],
})
export class OfertasImageViewerComponent implements OnInit {
    imagenes: ImageViewerItem[] = [];
    index = 0;

    constructor(
        public dialogRef: MatDialogRef<OfertasImageViewerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ImageViewerData
    ) {}

    ngOnInit(): void {
        if (this.data && this.data.imagenes && this.data.imagenes.length) {
            this.imagenes = this.data.imagenes;
            this.index = this.data.index || 0;
        } else if (this.data && this.data.url) {
            this.imagenes = [{ url: this.data.url, titulo: this.data.titulo }];
            this.index = 0;
        }

        if (this.index < 0 || this.index >= this.imagenes.length) {
            this.index = 0;
        }
    }

    get actual(): ImageViewerItem | null {
        return this.imagenes.length ? this.imagenes[this.index] : null;
    }

    get hayNavegacion(): boolean {
        return this.imagenes.length > 1;
    }

    get contador(): string {
        return this.imagenes.length ? `${this.index + 1} / ${this.imagenes.length}` : '';
    }

    prev(): void {
        if (!this.imagenes.length) {
            return;
        }
        this.index = (this.index - 1 + this.imagenes.length) % this.imagenes.length;
    }

    next(): void {
        if (!this.imagenes.length) {
            return;
        }
        this.index = (this.index + 1) % this.imagenes.length;
    }

    close(): void {
        this.dialogRef.close();
    }

    @HostListener('document:keydown', ['$event'])
    onKeydown(event: KeyboardEvent): void {
        if (event.key === 'ArrowLeft') {
            this.prev();
        } else if (event.key === 'ArrowRight') {
            this.next();
        } else if (event.key === 'Escape') {
            this.close();
        }
    }
}
